import { useMemo } from 'react';

import { PairDayData, PairToken } from '@app/types/pool';

interface Props {
  reserve0: string;
  reserve1: string;
  pairAddress: string;
  token0: PairToken;
  token1: PairToken;
  token0Price: string;
  token1Price: string;
  dayData?: PairDayData[] | undefined;
}

function getAprValue(todayDailyFee: number, totalLiquidity: number) {
  return ((todayDailyFee * 365) / totalLiquidity) * 100;
}

function getTokenValue(
  reserve: number,
  token: PairToken,
  fallBackPrice: string
) {
  const price0 = fallBackPrice ?? 0;

  return +reserve * +price0;
}

export function usePairAprV2({
  reserve0,
  reserve1,
  pairAddress,
  token0,
  token1,
  token0Price,
  token1Price,
  dayData
}: Props) {
  return useMemo(() => {
    if (!dayData) {
      return {
        prevApr: null,
        currentApr: null
      };
    }

    const token0Value = getTokenValue(+reserve0, token0, token0Price);
    const token1Value = getTokenValue(+reserve1, token1, token1Price);

    const totalLiquidity = token0Value + token1Value;

    const todayDailyFee = dayData[0] ? dayData[0].dailyFeeUSD : 0;
    const prevDailyFee = dayData[1] ? dayData[1].dailyFeeUSD : 0;

    return {
      prevApr:
        totalLiquidity > 0 ? getAprValue(+prevDailyFee, totalLiquidity) : null,
      currentApr:
        totalLiquidity > 0 ? getAprValue(+todayDailyFee, totalLiquidity) : null
    };
  }, [dayData, reserve0, reserve1, token0, token0Price, token1, token1Price]);
}
